<div class="otp-group" [class.otp-group--error]="error" [class.otp-group--success]="success">
    <input *ngFor="let digit of firstGroup; trackBy: trackByDigit"
           #digitInput
           type="text"
           inputmode="numeric"
           maxlength="1"
           class="otp-cell"
           [class.otp-cell--filled]="digits[digit] !== ''"
           [class.otp-cell--error]="error"
           [class.otp-cell--success]="success"
           [attr.aria-label]="'Digit ' + (digit + 1) + ' of 6'"
           [value]="digits[digit]"
           (input)="onDigitInput($event, digit)"
           (keydown)="onDigitKeydown($event, digit)"
           (paste)="onDigitPaste($event)"
           [disabled]="disabled">

    <div class="otp-separator" aria-hidden="true"></div>

    <input *ngFor="let digit of secondGroup; trackBy: trackByDigit"
           #digitInput
           type="text"
           inputmode="numeric"
           maxlength="1"
           class="otp-cell"
           [class.otp-cell--filled]="digits[digit] !== ''"
           [class.otp-cell--error]="error"
           [class.otp-cell--success]="success"
           [attr.aria-label]="'Digit ' + (digit + 1) + ' of 6'"
           [value]="digits[digit]"
           (input)="onDigitInput($event, digit)"
           (keydown)="onDigitKeydown($event, digit)"
           (paste)="onDigitPaste($event)"
           [disabled]="disabled">
</div>
